
/**
 * @param {string} url
 * */
export function pushHistoryState (url = '') {
  return window.history.pushState(null, null, url);
}

/**
 * @param {string} hash
 * */
export function stripHash (hash) {
  return hash ? decodeURIComponent(hash.replace('#', '')) : '';
}



// WEBPACK FOOTER //
// ./src/helpers/routing.js